import { render, staticRenderFns } from "./site-facing-multi-choice-history.vue?vue&type=template&id=653c7104&scoped=true&"
import script from "./site-facing-multi-choice-history.vue?vue&type=script&lang=js&"
export * from "./site-facing-multi-choice-history.vue?vue&type=script&lang=js&"
import style0 from "./site-facing-multi-choice-history.vue?vue&type=style&index=0&id=653c7104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c7104",
  null
  
)

component.options.__file = "site-facing-multi-choice-history.vue"
export default component.exports